import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { StatistikModalComponent } from './statistik-modal/statistik-modal.component';
import { StatistikProduktivitetComponent } from './produktivitet/statistik-produktivitet/statistik-produktivitet.component';
import { StatistikTidsforbrugComponent} from './tidsforbrug/statistik-tidsforbrug/statistik-tidsforbrug.component';
import { SharedModule } from '../shared/shared.module';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule } from '@angular/forms';
import { TimeKrFormatPipe } from './kunder/statistik-kunder-options/statistik-kunder-options-timeformat';
import { StatistikDaekningContainer } from './daekning/statistik-daekning/statistik-daekning.container';
import {
    StatistikIgangvaerendeFakturaModal
} from './igangvaerende/statistik-igangvaerende-kunde-faktura-modal/statistik-igangvaerende-faktura-modal';
import {
    StatistikIgangvaerendeSagsModalContainer
} from './igangvaerende/statistik-igangvaerende-kunde-sags-modal/statistik-igangvaerende-sags-modal.container';
import {
    StatistikIgangvaerendeSagsModal
} from './igangvaerende/statistik-igangvaerende-kunde-sags-modal/statistik-igangvaerende-sags-modal';
import {
    StatistikIgangvaerendeKundeDatoModal
} from './igangvaerende/statistik-igangvaerende-kunde-dato-modal/statistik-igangvaerende-kunde-dato-modal';
import { StatistikDaekningComponent } from './daekning/statistik-daekning/statistik.daekning.component';
import { StatistikIgangvaerendeComponent } from './igangvaerende/statistik-igangvaerende/statistik-igangvaerende.component';
import { StatistikIgangvaerendeContainer } from './igangvaerende/statistik-igangvaerende/statistik-igangvaerende.container';
import { StatistikIgangvaerendeKundeModal } from './igangvaerende/statistik-igangvaerende-kunde-modal/statistik-igangvaerende-kunde-modal';
import { StatistikModalSagContainer } from './kunder/statistik-kunder-sag-modal/statistik-modal-sag.container';
import { StatistikKunderPlantidModalComponent } from './kunder/statistik-kunder-plantid-modal/statistik-modal-plantid.component';
import { StatistikKunderSagModalComponent } from './kunder/statistik-kunder-sag-modal/statistik-modal-sag.component';
import { TotalIkkeKundeTidPipe } from './tidsforbrug/statistik-tidsforbrug/total-ikke-kunde-tid.pipe';
import { StatistikOptionsAfdelingerComponent } from './produktivitet/statistik-options-afdelinger/statistik-options-afdelinger.component';
import { StatistikOptionsGrupperComponent } from './produktivitet/statistik-options-grupper/statistik-options-grupper.component';
import { TotalFromPropertyPipe } from './produktivitet/statistik-produktivitet/total-from-property.pipe';
import { StatistikNormtidOptionsComponent } from './norm/statistik-normtid-options/statistik-normtid-options.component';
import { StatistikNormtidComponent } from './norm/statistik-normtid/statistik-normtid.component';
import { StatistikYdelseOptionsComponent } from './ydelse/statistik-ydelse-options/statistik-ydelse-options.component';
import { StatistikYdelseComponent } from './ydelse/statistik-ydelse/statistik-ydelse.component';
import { StatistikDaekningOptionsComponent } from './daekning/statistik-daekning-options/statistik-daekning-options.component';
import {
    StatistikIgangsvaerendeOptionsComponent
} from './igangvaerende/statistik-igangsvaerende-options/statistik-igangsvaerende-options.component';
import { StatistikKunderOptionsComponent } from './kunder/statistik-kunder-options/statistik-kunder-options.component';
import { StatistikKunderComponent } from './kunder/statistik-kunder/statistik-kunder.component';
import { StatistikTidsforbrugContainerComponent } from './tidsforbrug/statistik-tidsforbrug/statistik-tidsforbrug.container';
import { StatistikOptionsPeriodeComponent } from './produktivitet/statistik-options-periode/statistik-options-periode.component';
import { StatistikKunderContainerComponent } from './kunder/statistik-kunder/statistik-kunder.container';
import { StatistikProduktivitetContainerComponent } from './produktivitet/statistik-produktivitet/statistik-produktivitet.container';
import { StatistikDaekningKundeModal } from './daekning/statistik-daekning-kunde-modal/statistik-daekning-kunde-modal';
import { StatistikDaekningFakturaModal } from './daekning/statistik-daekning-faktura-modal/statistik-daekning-faktura-modal';
import { StatistikDaekningSagModal } from './daekning/statistik-daekning-sag-modal/statistik-daekning-sag-modal';
import {
    StatistikIgangvaerendeRetforventettabModal
} from './igangvaerende/statistik-igangvaerende-retforventettab-modal/statistik-igangvaerende-retforventettab-modal';
import { StatistikNormTimebudgetModal } from './norm/statistik-norm-timebudget-modal/statistik-norm-timebudget-modal';
import {
    StatistikTidsforbrugOptionsPeriodeComponent
} from './tidsforbrug/statistik-tidsforbrug-options-periode/statistik-tidsforbrug-options-periode.component';
import { StatistikYdelserContainer } from './ydelse/statistik-ydelse/statistik-ydelser.container';
import { StatistikNormtidContainer } from './norm/statistik-normtid/statistik-normtid.container';
import { StatistikOptionsFormlerComponent } from './produktivitet/statistik-options-formler/statistik-options-formler.component';
import {
    StatistikProduktivitetFormlerModal
} from './produktivitet/statistik-produktivitet-formler-modal/statistik-produktivitet-formler-modal';
import {
    StatistikProduktivitetEmployeeTimeLogModal
} from './produktivitet/statistik-produktivitet-employee-time-log-modal/statistik-produktivitet-employee-time-log-modal.component';
import {
    StatistikPlantidModalComponent
} from './tidsforbrug/statistik-plantid-modal/statistik-plantid-modal.component';
import {
    StatistikTidsforbrugIkkeKunderelateretTidModalComponent
} from './tidsforbrug/statistik-tidsforbrug-ikke-kunderelateret-tid-modal/statistik-tidsforbrug-ikke-kunderelateret-tid-modal.component';
import { StatistikModalPlantidContainer } from './kunder/statistik-kunder-plantid-modal/statistik-modal-plantid.container';
import { YdelseTimerKronerPipe } from './ydelse/statistik-ydelse/ydelse-timer-kroner.pipe';
import { CalcTotalForventetTabPipe } from './igangvaerende/statistik-igangvaerende-kunde-modal/calc-total-forventet-tab.pipe';
import { StatistikTilafgangComponent } from './tilafgang/statistik-tilafgang/statistik-tilafgang.component';
import { StatistikTilafgangContainerComponent } from './tilafgang/statistik-tilafgang/statistik-tilafgang.container';
import { StatistikTilafgangOptionsComponent } from './tilafgang/statistik-tilafgang-options/statistik-tilafgang-options.component';
import { StatistikNetomslaPipe } from './netomsla/statistik-netomsla/statistik-netomsla.pipe';
import { StatistikTilafgangGrundPipe } from './tilafgang/statistik-tilafgang/statistik-tilafgang-Grund-Counter.pipe';
import {StatistikKundeeditModalComponent} from './tilafgang/statistik-kundeedit-modal/statistik-kundeedit-modal.component';
import { StatistikNetomslaContainerComponent } from './netomsla/statistik-netomsla/statistik-netomsla.container';
import { StatistikNetomslaComponent } from './netomsla/statistik-netomsla/statistik-netomsla.component';
import { StatistikNetomslaOptionsComponent } from './netomsla/statistik-netomsla-options/statistik-netomsla-options.component';


@NgModule({
    declarations: [
        StatistikModalComponent,
        StatistikProduktivitetComponent,
        StatistikProduktivitetContainerComponent,
        StatistikOptionsFormlerComponent,
        StatistikProduktivitetFormlerModal,
        StatistikProduktivitetEmployeeTimeLogModal,
        StatistikKunderContainerComponent,
        StatistikOptionsPeriodeComponent,
        StatistikTidsforbrugComponent,
        StatistikPlantidModalComponent,
        StatistikTidsforbrugIkkeKunderelateretTidModalComponent,
        StatistikTidsforbrugContainerComponent,
        StatistikKunderComponent,
        StatistikKunderOptionsComponent,
        StatistikIgangsvaerendeOptionsComponent,
        StatistikIgangvaerendeComponent,
        StatistikDaekningComponent,
        StatistikDaekningOptionsComponent,
        StatistikYdelseComponent,
        StatistikYdelseOptionsComponent,
        StatistikNormtidComponent,
        StatistikNormtidOptionsComponent,
        TotalFromPropertyPipe,
        StatistikOptionsGrupperComponent,
        StatistikOptionsAfdelingerComponent,
        TotalIkkeKundeTidPipe,
        StatistikKunderSagModalComponent,
        StatistikKunderPlantidModalComponent,
        StatistikModalSagContainer,
        StatistikIgangvaerendeKundeModal,
        StatistikIgangvaerendeContainer,
        StatistikIgangvaerendeKundeDatoModal,
        StatistikIgangvaerendeSagsModal,
        StatistikIgangvaerendeSagsModalContainer,
        StatistikIgangvaerendeFakturaModal,
        StatistikDaekningContainer,
        StatistikDaekningKundeModal,
        StatistikDaekningSagModal,
        StatistikDaekningFakturaModal,
        StatistikIgangvaerendeRetforventettabModal,
        StatistikNormTimebudgetModal,
        StatistikTidsforbrugOptionsPeriodeComponent,
        StatistikYdelserContainer,
        StatistikNormtidContainer,
        TimeKrFormatPipe,
        StatistikModalPlantidContainer,
        YdelseTimerKronerPipe,
        CalcTotalForventetTabPipe,
        StatistikTilafgangContainerComponent,
        StatistikTilafgangComponent,
        StatistikTilafgangOptionsComponent,
        StatistikNetomslaOptionsComponent,
        StatistikTilafgangGrundPipe,
        StatistikKundeeditModalComponent,
        StatistikNetomslaContainerComponent,
        StatistikNetomslaComponent,
        StatistikNetomslaPipe,

    ],
    imports: [
        CommonModule,
        SharedModule,
        CdkTableModule,
        FormsModule,

    ]
})
export class StatistikModule {
}
